import { Grid } from "@mui/material";
import { fetchYourEmployeesCost } from "actions/costActions";
import { ReactComponent as YourEmployeesIcon } from "assets/cost/myemployees.svg";
import { DataUpdateInterval } from "components/Common/DataUpdateInterval";
import dayjs from "dayjs";
import {
	selectCurrentYourEmployeesCost,
	selectLastYourEmployeesCost,
	selectYourEmployeesCost,
} from "features/costs";
import { useApiOnceWithParams, useAppSelector } from "hooks/hooks";
import colors from "styles/utilities/_colors.scss";
import { IRONSTONE_PRODUCT_DISPLAY_NAMES } from "utilities/constants/constants";
import { CostType } from "utilities/constants/enums";
import { IronstoneServicesTable } from "../IronstoneServicesTable/IronstoneServicesTable";
import { CostTypeCard } from "../TotalsCards/CostTypeCard";
import styles from "./YourEmployeesCostView.module.scss";

const YourEmployeesCostView = () => {
	const { isLoading, isFetching } = useAppSelector(selectYourEmployeesCost);
	useApiOnceWithParams(fetchYourEmployeesCost, { isLoading, isFetching }, { numberOfMonths: 2 });

	const cost = useAppSelector(selectCurrentYourEmployeesCost);
	const costLastPeriod = useAppSelector(selectLastYourEmployeesCost);

	return (
		<Grid container className={styles.wrapper}>
			<Grid
				container
				className={styles.topSectionContainer}
				justifyContent="space-between"
				mb={3}
			>
				<Grid container className={styles.cardContainer}>
					<CostTypeCard
						isLoading={isLoading}
						title={IRONSTONE_PRODUCT_DISPLAY_NAMES.YOUR_EMPLOYEES}
						totalCurrentPeriod={cost?.totalCost ?? 0}
						totalPreviousPeriod={costLastPeriod?.totalCost}
						icon={<YourEmployeesIcon />}
						backgroundColor={colors.yellowTint1}
						size="medium"
						secondaryTitle="All purchased addons included"
						periodLabel={`${dayjs().startOf("month").format("DD.MM")} - ${dayjs()
							.endOf("month")
							.format("DD.MM")}`}
					/>
				</Grid>
				<Grid item className={styles.updateIntervalContainer} mt={3}>
					<DataUpdateInterval updateIntervalText={"Cost data updates every day"} />
				</Grid>
			</Grid>
			<Grid item xs={12}>
				<IronstoneServicesTable
					isLoading={isLoading}
					cost={cost}
					costType={CostType.YOUR_EMPLOYEES}
				/>
			</Grid>
		</Grid>
	);
};

export default YourEmployeesCostView;
